// Add global vendors here
import Vue from 'vue';
import BrowserDetect from './BrowserDetect.js';